<template>
	<div class="header2">
		<div class="frist" >Contact Us</div>
		
		<div class="second">"We will read all emails one by one, and I won't let any of them go unnoticed. Feel free to send us any message you'd like, but please include your Name and Email Address. Rest assured, you will only receive a reply from us."</div>
		
	</div>
</template>

<script>
	export default {
	  name: 'ConHeader',
	}
</script>

<style scoped>
	.header2{
		margin-top:60px;
		padding-top: 40px;
	}
	.frist{
		width:60%;
		font-size:40px;
		text-align:left;
		margin-left:20%;
		font-weight: 700; 
		display: none;
	}
	.second{
		width:60%;
		margin:25px 0 0 20%;
		font-size:16px;
		display: none;
	}
	
	
</style>